import { FormData } from 'src/components/SearchForm/SearchForm.types'
import {
  DataLayerEventType,
  DataLayerFactory,
  TmsContextType,
} from '@awaze/mfe-common.contexts.tms'

export const sendDataLayerSearchSubmitEvent = (
  formData: FormData,
  dataLayerErrorHandler: (error: string) => void,
  tms: TmsContextType,
): void =>
  new DataLayerFactory()
    .getEvent(DataLayerEventType.SearchSubmit)
    .update(tms, formData, dataLayerErrorHandler)
